import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['ios', 'android'];

  toggle(event) {
    const { value } = event.target;

    this.iosTarget.style.display = value === 'ios' ? '' : 'none';
    this.androidTarget.style.display = value === 'android' ? '' : 'none';
  }
}
